import { useSettings } from '@/hooks/useSettings';
import { useEffect } from 'react';
import { useAuth } from './AuthContext';

export const ModelFallback = () => {
  const { userPlanDetails } = useAuth();

  const { settings, updateSettings } = useSettings();

  //TODO this logic should not be here, maybe in a different context
  useEffect(() => {
    if (
      settings?.modelName === 'claude-3-7-sonnet-v1' ||
      settings?.modelName === 'claude-3-5-sonnet-v2'
    ) {
      updateSettings({
        ...settings,
        modelName: 'us.anthropic.claude-sonnet-4-20250514-v1:0',
      });
    }

    if (
      userPlanDetails?.planName === 'Free' &&
      settings?.modelName &&
      settings?.modelName !== 'gemini-2.5-flash-lite-preview-06-17'
    ) {
      updateSettings({
        ...settings,
        modelName: 'gemini-2.5-flash-lite-preview-06-17',
        maxLength: 250,
      });
    }
  }, [settings, updateSettings, userPlanDetails]);

  return null;
};
